import { isFinanceProject } from 'config';

export const getLegalClientCompanyHeadsFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['constituentDocsDateOfLastChange'];
  }

  return [];
};
